"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSkeleton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
/** 延遲多久才顯示骨架：多數請求在這之前就回來，載入很快時完全不閃 */
const DELAY_MS = 300;
const bar = 'h-4 rounded bg-slate-200 dark:bg-slate-700 animate-pulse';
/**
 * 表格載入骨架（只在第一次、沒有快取時出現）
 * 外框、格子間距與真正的表格相同（bg-surface、深色框線、rounded-lg、px-6 py-4），載入完換成表格時版面不跳
 * 不畫底部分頁：列表的分頁在表格上方
 * 延遲 300ms 才出現：多數請求在這之前就回來，不會閃一下骨架（主流做法：1 秒內完成不需要載入提示）
 */
const TableSkeleton = ({ rows = 5, columns = 5, showHeader = true, }) => {
    const [visible, setVisible] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => setVisible(true), DELAY_MS);
        return () => clearTimeout(timer);
    }, []);
    if (!visible)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { className: "bg-surface shadow dark:shadow-none dark:border dark:border-line overflow-hidden rounded-lg", "aria-busy": "true", "aria-live": "polite", children: (0, jsx_runtime_1.jsx)("div", { className: "overflow-x-auto", children: (0, jsx_runtime_1.jsxs)("table", { className: "min-w-full divide-y divide-line", children: [showHeader && ((0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: Array.from({ length: columns }).map((_, index) => ((0, jsx_runtime_1.jsx)("th", { className: "px-6 py-3 text-left", children: (0, jsx_runtime_1.jsx)("div", { className: `${bar} w-16` }) }, index))) }) })), (0, jsx_runtime_1.jsx)("tbody", { className: "divide-y divide-line", children: Array.from({ length: rows }).map((_, rowIndex) => ((0, jsx_runtime_1.jsx)("tr", { children: Array.from({ length: columns }).map((_, colIndex) => ((0, jsx_runtime_1.jsx)("td", { className: "px-6 py-4 whitespace-nowrap", children: (0, jsx_runtime_1.jsx)("div", { className: `${bar} ${colIndex === 0 ? 'w-3/4' : colIndex === 1 ? 'w-1/2' : colIndex === 2 ? 'w-2/3' : 'w-1/3'}`, style: { animationDelay: `${rowIndex * 0.1 + colIndex * 0.05}s` } }) }, colIndex))) }, rowIndex))) })] }) }) }));
};
exports.TableSkeleton = TableSkeleton;
exports.TableSkeleton.displayName = 'TableSkeleton';
